import { useNavigate } from 'react-router';
import { Box, Button, Card, CardContent, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { openBalance, openLogin, openRegister } from '../../../redux/slices/authUiSlice';
import Image from '../../../components/Image';
import TryItOutForms from './visitor/TryItOutForm';
import LoginForm from './visitor/LoginForm';
import Back from '../../../assets/home/back.png';
import { updateClock } from '../../../utils/update-clock';
import LanguagePopOver from './LanguagePopover';
import useAuth from '../../../hooks/useAuth';
import NotificationPopover from './NotificationPopover';
import NewLanguagePopover from './NewLanguagePopover';
import useLocales from '../../../hooks/useLocales';
import { dispatch, useSelector } from '../../../redux/store';
import { closeLoadingScreen, openLoadingScreen } from '../../../redux/slices/settings';
import conObj, { showResponseError } from '../../../utils/connection-assistant';
import BalanceNav from '../../../assets/navigation/mobileNavDrawer/wallet.png';
import Crown from '../../../assets/navigation/mobileNavDrawer/crown.png';
import Egames from '../../../assets/navigation/mobileNavDrawer/eGames.png';

import SlotLeftNav from '../../../assets/navigation/slot-left-nav.png';
import EventLeftNav from '../../../assets/navigation/event-left-nav.png';
import AcewinLeftNav from '../../../assets/navigation/acewin-left-nav.png';
import JiliLeftNav from '../../../assets/navigation/jili-left-nav.png';
import CasinoLeftNav from '../../../assets/navigation/casino-left-nav.png';
import SportsLeftNav from '../../../assets/navigation/sports-left-nav.png';
import BrandLogo from '../../../assets/brand-logo.png';
import PersonLogo from '../../../assets/personLogo.png';
import Register from './visitor/Register';
import useResponsive from '../../../hooks/useResponsive';
import Iconify from '../../../components/Iconify';
import { fNumberDecimal } from '../../../utils/formatNumber';
import { getUserMemberBalance } from '../../../redux/slices/lookup';
import { openConfirm } from '../../../redux/slices/confirm';

const LeftNavigation = ({ src, title, onClick, onClose }) => {
  const { translate } = useLocales();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        height: '40px',
      }}
    >
      <Box
        display={'flex'}
        alignItems={'center'}
        gap={1}
        onClick={() => {
          if (onClick) onClick();
          if (onClose) onClose();
        }}
      >
        <Box
          sx={{
            backgroundColor: '#FEAD00',
            padding: 0.3,
            borderRadius: 0.2,
          }}
        >
          <Image sx={{ width: '12px', height: '12px' }} src={src} alt={title} />
        </Box>
        <Typography sx={{ fontSize: '12px' }}>{translate(title)}</Typography>
      </Box>
    </Box>
  );
};

const DashboardHeader = () => {
  const navigate = useNavigate();
  const { gameCategsAndCompanies } = useSelector((x) => x.lookup);
  const { translate } = useLocales();
  const dispatchUi = useDispatch();
  const theme = useTheme();
  const { isAuthenticated } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [time, setTime] = useState('');
  const isDesktop = useResponsive('up', 'lg');
  const [isLoadingBalance, setIsLoadingBalance] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [customArrangements, setCustomArrangements] = useState([]);

  const [customGameCategories, setCustomGameCategories] = useState([]);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const [openLanguagePopover, setOpenLanguagePopover] = useState(false);

  useEffect(() => {
    updateClock(setTime);

    const interval = setInterval(() => updateClock(setTime), 1000);

    return () => clearInterval(interval);
  }, []);

  const classicIcon = [
    SlotLeftNav,
    CasinoLeftNav,
    AcewinLeftNav,
    JiliLeftNav,
    BalanceNav,
    Egames,
    Crown,
    SportsLeftNav,
  ];

  const customGameCategoriesData = useMemo(
    () => [
      ...(gameCategsAndCompanies || []).map((item, index) => ({
        ...item,
        classicIcon: classicIcon[index],
        onClick: () => {
          navigate(`/arrangement/${item.slug}`);
        },
      })),

      {
        classicIcon: classicIcon[4],
        name: 'Balance',
        onClick: () => {
          if (!isAuthenticated) {
            dispatchUi(openLogin());
          } else {
            dispatchUi(openBalance());
          }
        },
      },

      {
        classicIcon: classicIcon[6],
        name: 'VIP',
        onClick: () => {
          navigate('/vip');
        },
      },
    ],
    [gameCategsAndCompanies]
  );

  const { memberBalance } = useSelector((x) => ({
    ...x.lookup,
  }));

  const clearBalance = () =>
    // if (memberBalance?.balance < 1) {
    conObj
      .post('/members/clear_balance.json')
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.data.status === 1) {
            enqueueSnackbar(res?.data?.data?.msg, {
              variant: 'success',
              autoHideDuration: 5000,
            });
            getUserMemberBalance();
          } else {
            enqueueSnackbar(res?.data?.data?.msg, {
              variant: 'error',
              autoHideDuration: 5000,
            });
          }
        }
      })
      .catch((err) => {
        showResponseError(err, enqueueSnackbar);
      });

  return (
    <Box>
      {isDesktop && (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          sx={{ backgroundColor: theme.palette.goldcity.background.main }}
        >
          <Box
            sx={{
              width: '1250px',
              paddingY: { md: '8px' },
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box display={'flex'} gap={5} alignItems={'center'} justifyContent={'end'}>
              <NewLanguagePopover
                hasIcon
                hasLabel
                open={openLanguagePopover}
                handleOpen={() => setOpenLanguagePopover(true)}
                handleClose={() => setOpenLanguagePopover(false)}
              />

              {isAuthenticated && <NotificationPopover />}
            </Box>
            {/* LEFT SECTION */}
            {/* <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 2, md: '24px', margin: 0, padding: 0 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Image
                  sx={{ width: '24px', height: '20px' }}
                  src={require('../../../assets/home/hand-shake.png')}
                  alt="Đại lý"
                  aria-hidden="true"
                />
                <Typography sx={{ color: '#fff' }}>Đại lý</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Image
                  sx={{ width: '24px', height: '20px' }}
                  src={require('../../../assets/home/headphones.png')}
                  alt="CSKH 24/7"
                  aria-hidden="true"
                />
                <Typography sx={{ color: '#fff' }}>CSKH 24/7</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Image
                  sx={{ width: '24px', height: '20px' }}
                  src={require('../../../assets/home/people.png')}
                  alt="GTBB"
                  aria-hidden="true"
                />
                <Typography sx={{ color: '#fff' }}>GTBB</Typography>
              </Box>
            </Box> */}

            {/* RIGHT SECTION */}
            {!isAuthenticated && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <Button
                  onClick={() => dispatchUi(openLogin())}
                  sx={{
                    fontWeight: 300,
                    width: '128px',
                    backgroundColor: '#FFC107',
                    borderColor: '#fff',
                    color: '#000',
                    borderRadius: '20px',
                    '&:hover': { backgroundColor: '#ffca2c' },
                  }}
                >
                  {translate('login')}
                </Button>
                <Button
                  onClick={() => dispatchUi(openRegister())}
                  variant="outlined"
                  sx={{
                    fontWeight: 300,
                    width: '128px',
                    color: '#fff',
                    borderColor: '#fff',
                    borderRadius: '20px',
                    '&:hover': {
                      borderColor: '#FFC107',
                      color: '#FFC107',
                    },
                  }}
                >
                  {translate('register')}
                </Button>
              </Box>
            )}

            {isAuthenticated && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderRadius: '999px',
                    padding: '2px 14px',
                    width: 'fit-content',
                    color: '#FFC107',
                    background: 'rgba(255, 193, 7, 0.1)',
                    border: '1px solid rgba(255, 193, 7, 0.4)',
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    {translate('balance')}：
                    {`${memberBalance?.currencyCode} ${
                      memberBalance?.displayBalance ? fNumberDecimal(memberBalance?.displayBalance) : 0
                    }`}
                  </Typography>

                  <IconButton
                    onClick={() => {
                      if (!isLoadingBalance) {
                        setIsLoadingBalance(true);
                        getUserMemberBalance().finally(() => setIsLoadingBalance(false));
                      }
                    }}
                    size="small"
                    sx={{
                      color: '#F5A623',
                      ml: 1,
                    }}
                  >
                    <Iconify
                      icon="mdi:refresh"
                      width={18}
                      height={18}
                      sx={{
                        animation: isLoadingBalance ? 'spin 1s linear infinite' : 'none',
                        '@keyframes spin': {
                          '0%': { transform: 'rotate(0deg)' },
                          '100%': { transform: 'rotate(360deg)' },
                        },
                      }}
                    />
                  </IconButton>

                  {memberBalance.canClearBalance && (
                    <IconButton
                      onClick={() => {
                        if (isAuthenticated) {
                          dispatch(
                            openConfirm({
                              title: translate('clear_balance'),
                              subTitle: translate('this_will_set_balance'),
                              onConfirm: () => clearBalance(),
                            })
                          );
                        }
                      }}
                      size="small"
                      sx={{
                        color: '#F5A623',
                        ml: 1,
                      }}
                    >
                      <Iconify icon="mdi:close" width={18} height={18} />
                    </IconButton>
                  )}
                </Box>
                <Button
                  onClick={() => navigate('/user/wallet?tab=deposit')}
                  sx={{
                    fontWeight: 500,
                    width: '128px',
                    backgroundColor: '#FFC107',
                    color: '#000',
                    borderRadius: '20px',
                    '&:hover': { backgroundColor: '#ffca2c' },
                  }}
                >
                  {translate('deposit')}
                </Button>
                <Button
                  onClick={() => navigate('/user/wallet?tab=withdraw')}
                  variant="outlined"
                  sx={{
                    fontWeight: 500,
                    width: '128px',
                    backgroundColor: '#FFC107',
                    color: '#000',
                    borderRadius: '20px',
                    '&:hover': { backgroundColor: '#ffca2c' },
                  }}
                >
                  {translate('Withdraw')}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      )}

      {/* MOBILE */}
      {!isDesktop && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
          }}
        >
          <Card sx={{ position: 'relative', borderRadius: 0 }}>
            <CardContent
              component="video"
              loop
              autoPlay
              muted
              controls={false}
              sx={{
                padding: '0 !important',
                objectFit: 'cover',
                width: '100%',
              }}
            >
              <source src="https://media.88new11.com/public/new88/site-tong/8e23cdf7-af1b-495c-be24-934c2338ed5f.mp4" />
            </CardContent>
          </Card>
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              left: 10,
              right: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <IconButton
              onClick={toggleDrawer(true)}
              sx={{
                p: '1.5px',
                borderRadius: '50%',
                background:
                  'linear-gradient(#1A1A1A, #1A1A1A) padding-box, ' +
                  'linear-gradient(180deg, #FDD146 0%, #F09F0E 100%) border-box',
                border: '1.2px solid transparent',
                width: '8vw',
                height: '8vw',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
            >
              <Image
                sx={{
                  width: '4.5vw',
                  height: '4.5vw',
                }}
                src={require('../../../assets/home/menu.png')}
                alt="Menu"
                aria-hidden="true"
              />
            </IconButton>
            <Image
              onClick={() => navigate('/', { replace: true })}
              sx={{ width: '30vw', height: '9vw', cursor: 'pointer' }}
              src={BrandLogo}
              alt="GTBB"
              aria-hidden="true"
            />
            <Box
              sx={{
                position: 'relative',
                cursor: 'pointer',
              }}
            >
              {/* <Image
                sx={{ width: '100%', height: '100%' }}
                src={require('../../../assets/home/bell-hover.png')}
                alt="Notification Bell"
                aria-hidden="true"
              /> */}
              {isAuthenticated && <NotificationPopover withLabel={true} />}

              {/* Small red notification dot */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '0.8vw',
                  height: '0.8vw',
                  bgcolor: 'red',
                  borderRadius: '50%',
                  border: '2px solid white', // white border to separate from bell icon
                }}
              />
            </Box>
          </Box>
        </Box>
      )}

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: '50%',
            background: 'linear-gradient(180.0deg, #313131 0%, #121212 100%)',
            color: '#fff',
            boxShadow: '0 -2px 8px 0 rgba(0,0,0,0.4)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingX: 1,
          }}
        >
          <Box
            sx={{
              mt: 1,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Image
              onClick={() => {
                navigate('/');
                toggleDrawer(false)();
              }}
              sx={{
                width: '60%',
                height: 'auto',
                flexGrow: 1,
                flexShrink: 0,
                cursor: 'pointer',
              }}
              src={BrandLogo}
              alt="GTBB"
              aria-hidden="true"
            />
            <IconButton onClick={toggleDrawer(false)}>
              <Image sx={{ width: '25px', height: '18px' }} src={Back} alt="GTBB" aria-hidden="true" />
            </IconButton>
          </Box>

          <Image src={PersonLogo} alt="GTBB" aria-hidden="true" />
        </Box>

        <Typography textAlign={'center'} fontSize={'.75rem'}>
          {time} GMT-4
        </Typography>
        <Box
          sx={{
            overflowY: 'auto',
            paddingX: '8px',
            flexShrink: 0,
            scrollbarWidth: 'none',
            height: 'calc(100vh - 200px)',
          }}
        >
          {customGameCategoriesData.map((data, index) => (
            <LeftNavigation
              key={index}
              src={data.classicIcon}
              title={data.name}
              onClick={data.onClick}
              onClose={toggleDrawer(false)}
            />
          ))}
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              height: '40px',
            }}
          >
            <Box
              display={'flex'}
              alignItems={'center'}
              gap={1}
              onClick={() => {
                setOpenLanguagePopover(true);
                setDrawerOpen(false);
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#FEAD00',
                  padding: 0.3,
                  borderRadius: 0.2,
                }}
              >
                <Image sx={{ width: '12px', height: '12px' }} src={CasinoLeftNav} alt={'language'} />
              </Box>
              <Typography sx={{ fontSize: '12px' }}>{translate('change_language')}</Typography>
            </Box>
          </Box>
        </Box>
      </Drawer>

      <NewLanguagePopover
        open={openLanguagePopover}
        handleOpen={() => setOpenLanguagePopover(true)}
        handleClose={() => setOpenLanguagePopover(false)}
      />
    </Box>
  );
};

export default DashboardHeader;
